// extracted by mini-css-extract-plugin
export default {"wrapper":"TsmFe","container":"yPAfN","buttonsContainer":"TnYnX","confirmModalButton":"voV6F"};